export default __webpack_public_path__ + "static/media/heavy_equipment_operator_jobs.f65e0c3f.png";